var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 57,
    fill: "#EF545D",
    fillOpacity: 0.2,
    stroke: "#EF545D",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6442 37.3636L61.9411 68.1733H55.0803L54.3984 37.3636H62.6442ZM58.5107 81.4688C57.218 81.4688 56.1101 81.0142 55.1868 80.1051C54.2777 79.196 53.8232 78.0881 53.8232 76.7812C53.8232 75.5028 54.2777 74.4091 55.1868 73.5C56.1101 72.5909 57.218 72.1364 58.5107 72.1364C59.7749 72.1364 60.8686 72.5909 61.7919 73.5C62.7294 74.4091 63.1982 75.5028 63.1982 76.7812C63.1982 77.6477 62.978 78.4361 62.5376 79.1463C62.1115 79.8565 61.5433 80.4247 60.8331 80.8509C60.1371 81.2628 59.3629 81.4688 58.5107 81.4688Z",
    fill: "#EF545D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/Wrong.5405cebb017352f13367351810a45019.svg";
export { ForwardRef as ReactComponent };